/**
 * 订单ID
 * @description 缩略显示，支持复制
 */

import { CopyIcon } from '@bfe/moly-icons';
import { useFm, useToast } from '@web3/base-hooks';
import { useCopyToClipboard } from 'react-use';

interface OrderIdProps {
  orderId: string;
}

const formatOrderId = (orderId: string) => {
  if (orderId.startsWith('0x')) {
    const id = orderId.replace(/0+$/g, '');
    return `${id.substr(0, 4)}...${id.substr(-4)}...`;
  }
  return `${orderId.substr(0, 4)}...${orderId.substr(-4)}`;
};

export default function OrderId({ orderId }: OrderIdProps) {
  const [, copy] = useCopyToClipboard();
  const { toastSuccess } = useToast();
  const fm = useFm();

  const handleCopy = () => {
    copy(orderId);
    toastSuccess(fm('copied'));
  };

  return (
    <div
      className="flex items-center cursor-pointer hover:text-[#9747ff]"
      onClick={handleCopy}
    >
      <span>{formatOrderId(orderId)}</span>
      <CopyIcon />
    </div>
  );
}
